export enum PermissionArea {
    BRANDS_CONFIGURATION = 'BRANDS_CONFIGURATION',
    CO_ACQUISITION_CONFIGURATION = 'CO_ACQUISITION_CONFIGURATION',
    DOCUMENTS_MANAGEMENT = 'DOCUMENTS_MANAGEMENT',
    DOCUMENTS_VIEW = 'DOCUMENTS_VIEW',
    LOCALIZATION_LIST = 'LOCALIZATION_LIST',
    LOCALIZATION_MANAGEMENT = 'LOCALIZATION_MANAGEMENT',
    MARKETING_REPORT = 'MARKETING_REPORT',
    PARTNER_LIST = 'PARTNER_LIST',
    PARTNER_MANAGEMENT = 'PARTNER_MANAGEMENT',
    PARTENON_MANAGEMENT = 'PARTENON_MANAGEMENT',
    PASSWORD_POLICY_MANAGEMENT = 'PASSWORD_POLICY_MANAGEMENT',
    POLICY_REGISTRY = 'POLICY_REGISTRY',
    PRODUCT_CPI_LIST = 'PRODUCT_CPI_LIST',
    PRODUCT_CPI_MANAGEMENT = 'PRODUCT_CPI_MANAGEMENT',
    PRODUCT_UPG_MANAGEMENT = 'PRODUCT_UPG_MANAGEMENT',
    SALES_CPI = 'SALES_CPI',
    SALES_UPG = 'SALES_UPG',
    TARIFF_ELEMENT_CONFIGURATION = 'TARIFF_ELEMENT_CONFIGURATION',
    TRANSCODER_CONFIGURATION = 'TRANSCODER_CONFIGURATION',
    USER_LIST = 'USER_LIST',
    USER_MANAGEMENT = 'USER_MANAGEMENT',
    USERS_REPORT = 'USERS_REPORT',

    // frontend specific Areas - special conditions in acl.service.ts
    MANAGEMENT = 'MANAGEMENT',
    CONFIGURATION = 'CONFIGURATION',
    LOCALIZATION_MANAGEMENT_LIMITED = 'LOCALIZATION_MANAGEMENT_LIMITED',
    PRODUCT_MANAGEMENT = 'PRODUCT_MANAGEMENT',

    MIGRATED_POLICY_REGISTRY = 'MIGRATED_POLICY_REGISTRY',
    MIGRATED_POLICY_CANCELLATION = 'MIGRATED_POLICY_CANCELLATION',
    MIGRATED_POLICY_LOSS_RATIO_VIEW = 'MIGRATED_POLICY_LOSS_RATIO_VIEW',

    REPOSITORY_POLICIES_REGISTRY = 'REPOSITORY_POLICIES_REGISTRY',
    REPOSITORY_POLICY_VIEW = 'REPOSITORY_POLICY_VIEW',
    REPOSITORY_POLICY_LOSS_RATIO_VIEW = 'REPOSITORY_POLICY_LOSS_RATIO_VIEW',
    REPOSITORY_POLICY_PRINTOUT = 'REPOSITORY_POLICY_PRINTOUT',
    REPOSITORY_POLICY_CANCELLATION = 'REPOSITORY_POLICY_CANCELLATION',
    REPOSITORY_POLICY_MODIFY = 'REPOSITORY_POLICY_MODIFY',
    REPOSITORY_POLICY_FILE_UPLOAD = 'REPOSITORY_POLICY_FILE_UPLOAD',
}
